/**
* web
*/

import '@common/polyfill/src/promise'
import cookies from 'js-cookie'
import urlTool from '@common/url'
import { domain } from '@finance/domain'
import useragent from '@finance/useragent'
import { urlParams } from '@common/loan-act/util'
import { callbackHandler } from '../utils'
import { clearCookies } from '@finance/login-cookie'

import BaseAuth from './base'

class WebAuth extends BaseAuth {
  constructor(options) {
    super(options)
    if (!useragent.isSuishouji && !useragent.isSuiguanjia && !useragent.isKaniu) {
      this.isClientHit = true
    }
  }
  // 获取token
  getToken() {
    if (!this.isClientHit) return undefined
    return Promise.resolve({})
  }
  clientDataHandler(token) {
    const tokenError = () => {
      callbackHandler(this.options.error, { msg: '登录失败' })
    }
    const tokenExpire = () => {
      callbackHandler(this.options.error, { msg: '登录失败，token过期' })
      console.warn('登录失败', 'Api login Error: refresh times out')
    }
    this.requestLoginApi({ token, tokenType: 'Bearer', loginState: true }, {
      tokenExpire,
      tokenError,
      accountError: tokenError
    })
  }
  // 登录
  login() {
    const { token } = urlParams() || {}

    if (!this.isClientHit) return
    if (token && this.loginType.silent) {
      this.clientDataHandler(token)
    } else if (!token && this.loginType.silent && useragent.isMiniProgram) {
      // 小程序无token时清除登录
      clearCookies(['ssj_id', 'ssj_uid', 'isLogin', 'ssj_token'])
      callbackHandler(this.options.error, { msg: '登录失败' })
    } else if (this.checkIsLogin()) {
      const cookieToken = cookies.get('ssj_token')
      cookieToken ? this.clientDataHandler(cookieToken) : this.requestLoginApiSuccessCallback()
    } else if (this.loginType.silent) {
      // 如果是静默登录，或已登录，支持后续事件
      this.requestLoginApiSuccessCallback()
    } else {
      cookies.set('success_forwardUrl', this.options.forwardUrl, { domain: urlTool('domain') })
      window.location.href = `${domain.feideeRes}/cab-common/login/index.html#/`
    }
  }
}

export default WebAuth
